import { Route, Routes, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import "./App.scss";
import Footer from "./component/Footer";
import Header from "./component/Header";
// import ScrollToTop from "./component/ScrollToTop";
import Home from "./pages/Home";
import { useFontLoader } from "./hooks/useFontLoader";

// const PageNotFound = lazy(() => import("./component/PageNotFound"));
const MyBykRent = lazy(() => import("./pages/MyBykRent"));
const Success = lazy(() => import("./pages/Success"));
const ErrorPage = lazy(() => import("./pages/Error"));
const Pending = lazy(() => import("./pages/Pending"));
const PageNotFound = lazy(() => import("./pages/NotFound/PageNotFound"));
const ProcessingPayment = lazy(() => import("./pages/PaymentProcessing"));

const App = () => {
  const location = useLocation();
   useFontLoader();
  return (
    <Suspense fallback={<h1 className="loading-title">Loading...</h1>}>
      <main>
        {location.pathname === "/" && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mybykrent" element={<MyBykRent />} />
          <Route path="/mybykrent/success" element={<Success />} />
          <Route path="/mybykrent/error" element={<ErrorPage />} />
          <Route path="/mybykrent/pending" element={<Pending />} />
          <Route
            path="/mybykrent/processing-payment"
            element={<ProcessingPayment />}
          />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/404" element={<PageNotFound />} />
        </Routes>
        {location.pathname === "/" && <Footer />}
      </main>
    </Suspense>
  );
};

export default App;